import React from 'react';
import VirtualEntryListContainer from './VirtualEntryListContainer.jsx';

const VirtualEventDetail = () => (
  <div className="animated fadeIn">
    <div className="row flex center">
      <div className="col-xs-12">
        <VirtualEntryListContainer />
      </div>
    </div>
  </div>
);

export default VirtualEventDetail;



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEventDetail.jsx